@if (personne) {
  <div class="personne-infos">
    @if (photoData != null) {
      <div class="photo-part"  (click)="navigateToFichePersonne()">
        <img [src]="photoData" alt="photo">
      </div>
    }
    <div class="infos-part" (click)="navigateToFichePersonne()">
      <div class="nomprenom">{{personne.nom}} {{personne.prenom}}</div>
      @if (hasTelephone) {
        <div class="tel"><i class="icon icon-phone"></i>{{personne.telephone}}</div>
      }
      @if (hasEmail) {
        <div class="email"><i class="icon icon-mail"></i>{{personne.email}}</div>
      }
    </div>
  </div>
}

